import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportDeltaShekelMarketFetch } from './actions';

export const sagasReportDeltaShekelMarket = [
  takeLatest(actionReportDeltaShekelMarketFetch.rejected, workerErrorNotifyThunk),
];
